export class UserBranchDetail {
    constructor() {
        this.User = null; //user Class
        this.Branch = null; // Branch Class
        this.IsDefaultBranch = false;
    }
}